import { render, staticRenderFns } from "./AtmRewardEditor.vue?vue&type=template&id=0ddfe18c&scoped=true"
import script from "./AtmRewardEditor.vue?vue&type=script&lang=ts"
export * from "./AtmRewardEditor.vue?vue&type=script&lang=ts"
import style0 from "./AtmRewardEditor.vue?vue&type=style&index=0&id=0ddfe18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddfe18c",
  null
  
)

export default component.exports